import { UserImage as UiKitUserImage } from "@circle-react-uikit/UserImage";
import thinkingGif from "./thinking.gif";

interface ThinkingAvatarProps {
  name: string;
}

export const ThinkingAvatar = ({ name }: ThinkingAvatarProps) => (
  <UiKitUserImage isFullRounded name={name} size="9" src={thinkingGif} />
);
